// extracted by mini-css-extract-plugin
export default {"main":"RootLayout_main__odY7v"};